import { useEffect } from 'react'

import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader'
import { authClient } from '#features/auth/auth-service.ts'
import { useCurrentUser } from '#features/common/hooks/use-current-user'
import { getLastUsedWorkspace } from '#lib/last-used-workspace.ts'

export const Route = createFileRoute('/_app/')({
  beforeLoad: async () => {
    const session = await authClient.getSession()

    if (!session.data?.session) {
      throw redirect({ to: '/login' })
    }

    return null
  },
  pendingComponent: DefaultLoader,
  component: AuthenticatedRootRedirect,
})

function AuthenticatedRootRedirect() {
  const [user] = useCurrentUser()
  const navigate = useNavigate()

  // Prefer the workspace the user last visited (tracked in a cookie by
  // useWorkspace); fall back to the first workspace when the cookie is
  // missing or points to a workspace they no longer have access to.
  const lastUsedSlug = getLastUsedWorkspace()
  const workspace =
    user.workspaces.find((w) => w.slug === lastUsedSlug) ?? user.workspaces[0]

  useEffect(() => {
    if (!workspace) {
      navigate({ to: '/getting-started' })
      return
    }

    navigate({
      to: '/$workspace',
      params: {
        workspace: workspace.slug,
      },
    })
  }, [navigate, workspace])

  return <DefaultLoader />
}
